const GenerationType = require('../enums/GenerationType');
const DraftPromptReplacements = require('../enums/DraftPromptReplacements');

const PROMPTS = [
  {
    index: 0,
    type: GenerationType.DEDICATION,
    message: `
      As a biography researcher, search the interview transcript provided between <transcript> </transcript> XML tags and write a suitable short dedication paragraph based on the interviewees' requests. 
      Make sure it is compelling and moving. Use the interviewees' voice and language to ensure authenticity.
      Then provide the dedication.
    `,
  },
  {
    index: 0,
    type: GenerationType.TITLE_IDEAS,
    message: `
      As a biography researcher, search the interview transcript provided between <transcript> </transcript> XML tags and provide some suggested titles or names for the biography book.
      You may use the conversations or suggestions within the interview transcript to create these titles.
      Then provide 3 to 5 varied titles.
    `,
  },
  {
    index: 0,
    type: GenerationType.BOOK_SAMPLE,
    name: '0. Anecdote Extraction (First Person)',
    message: 'As a biography researcher, look through the interview transcript and write the following in first person:\n\n1: An amusing anecdote. Include all connected details and expanded context for an intimate understanding of the story.\n\n2: A compelling turning point or life milestone story. Include all connected details and expanded context for an intimate understanding of the story.\n\n3: A Realisation story. Include all connected details and expanded context for an intimate understanding of the story.\n\n4: A Life lesson that will help others. Include all connected details and expanded context for an intimate understanding of the lesson.',
  },
  {
    index: 1,
    type: GenerationType.BOOK_SAMPLE,
    name: '1. Inspirational and uplifting',
    message: '“XXXX Output from the first prompt goes here XXXX\n\nRewrite this in an inspirational and uplifting style',
  },
  {
    index: 2,
    type: GenerationType.BOOK_SAMPLE,
    name: '2. Formal',
    message: '“XXXX Output from the first prompt goes here XXXX\n\nRewrite this in a formal style',
  },
  {
    index: 0,
    type: GenerationType.STYLE_SAMPLES,
    name: '0. Anecdote Extraction (First Person)',
    message: 'As a biography researcher, look through the interview transcript and write the following in first person:\n\n1: An amusing anecdote. Include all connected details and expanded context for an intimate understanding of the story.\n\n2: A compelling turning point or life milestone story. Include all connected details and expanded context for an intimate understanding of the story.\n\n3: A Realisation story. Include all connected details and expanded context for an intimate understanding of the story.\n\n4: A Life lesson that will help others. Include all connected details and expanded context for an intimate understanding of the lesson.',
  },
  {
    index: 1,
    type: GenerationType.STYLE_SAMPLES,
    name: '1. Inspirational and uplifting',
    message: '“XXXX Output from the first prompt goes here XXXX\n\nRewrite this in an inspirational and uplifting style',
  },
  {
    index: 2,
    type: GenerationType.STYLE_SAMPLES,
    name: '2. Formal',
    message: '“XXXX Output from the first prompt goes here XXXX\n\nRewrite this in a formal style',
  },
  {
    index: 0,
    type: GenerationType.OUTLINE,
    name: '0. Anecdote Extraction (First Person)',
    message: 'As a biography researcher, look through the interview transcript and write the following in first person:\n\n1: An amusing anecdote. Include all connected details and expanded context for an intimate understanding of the story.\n\n2: A compelling turning point or life milestone story. Include all connected details and expanded context for an intimate understanding of the story.\n\n3: A Realisation story. Include all connected details and expanded context for an intimate understanding of the story.\n\n4: A Life lesson that will help others. Include all connected details and expanded context for an intimate understanding of the lesson.',
  },
  {
    index: 1,
    type: GenerationType.OUTLINE,
    name: '1. Prep Questions',
    message: 'Read the interview transcript. As a biography researcher, answer the following questions:\n\n1: Is the title or name of the biography book discussed in the interview transcripts? If not, suggest 3 suitable titles.\n\n2: Are there any specific requests mentioned in the interview transcripts regarding the biography book that we should be aware of?\n\n3: Are there any topics or content that the interviewee would like to be avoided when writing the biography book?\n\n4: Is there a theme or purpose mentioned about the book discussed?',
  },
  {
    index: 2,
    type: GenerationType.OUTLINE,
    name: '2. Generate Outline',
    message: 'Using the interview transcript provided between <transcript> tags, write an extensive biography outline for the interviewees\' life chronologically.\n\nEach of the chapter outlines must include:\n\n1.A creative and engaging chapter title relevant to the interviewee.\n\n2.A chapter overview paragraph in first-person perspective.\n\n3.Between 7 to 15 extensive bullet points covering very rich and thorough details such as names, dates, times, people, relationships, feelings, emotions, anecdotes, life lessons and any compelling content related to that chapter in first-person perspective.\n\nBe thorough. Do not rush.\n\nThen determine the appropriate placement and ensure these additional elements are also included in the biography outline:\n\nXXXXXX',
  },
  {
    index: 3,
    type: GenerationType.OUTLINE,
    name: '3. Find Additional Outline Content',
    message: 'I have provided a biography outline and an interview transcript, can you tell the difference between each?\n\nIs there any compelling content including anecdotes and stories in the transcript that are missing from the outline?\n\nList these in the correct chronological order to enrich the outline.',
  },
  {
    index: 4,
    type: GenerationType.OUTLINE,
    name: '4. Generate Chapters',
    message: 'Write chapter XXX: "XXX" with over 1500 words in first-person format like a biography using only source information from the attached transcripts.\n\nHere are your rules:\n\n- Write a non-fiction chapter\n\n- Remain faithful to the transcripts\n\n- Use the interviewees\' language when writing and take relevant quotes from the transcripts\n\n- IMPORTANT: Enrich the chapter with additional content found in the transcripts that fit chronologically\n\n- Write the chapter chronologically\n\nHere is an overview for bounding the chapter:\n\nXXX\n\nEnd the chapter, creatively introducing the next section: "XXX" Do not write chapter XXX.',
  },
  {
    index: 0,
    type: GenerationType.DRAFT,
    name: 'Generate Chapter Draft',
    message: `Write chapter <<${DraftPromptReplacements.CHAPTER_NUMBER}>>: "<<${DraftPromptReplacements.CHAPTER_TITLE}>>" with over 2000 words in first-person format like a biography using only source information from the attached transcripts.\n\nHere are your rules:\n\u2022 Write a non-fiction chapter\n\u2022 Remain faithful to the transcripts\n\u2022 Use the interviewees' language when writing and take relevant quotes from the transcripts\n\u2022 IMPORTANT: Enrich the chapter with additional content found in the transcripts that fit chronologically\n\u2022 Write the chapter chronologically\n\nHere is an overview for bounding the chapter:\n<<${DraftPromptReplacements.CHAPTER_OVERVIEW}>>\n<<${DraftPromptReplacements.PROMPT_PS_DIVIDER}>>\nEnd the chapter, creatively introducing the next chapter: "<<${DraftPromptReplacements.NEXT_CHAPTER_TITLE}>>" Do not write chapter <<${DraftPromptReplacements.NEXT_CHAPTER_NUMBER}>>.`,
  },
];

module.exports = PROMPTS;
